import { RuleObject } from 'antd/es/form';

import { ProxyServerFormValidationSchema } from '../../../proxyServers.interfaces';

export const proxyServersFormValidationSchema: ProxyServerFormValidationSchema = {
  name: [
    { required: true, message: 'Введіть назву проксі-сервера' },
    { type: 'string', message: 'Назва має бути строкою' },
    { min: 3, max: 255, message: 'Назва має бути довжиною не менше 3 символа та не більше 255' }
  ],
  password: [
    { required: true, message: 'Введіть паролю для доступу' },
    { type: 'string', message: 'Пароль має бути строкою' },
    { min: 1, max: 255, message: 'Пароль має бути довжиною не менше 1 символа та не більше 255' }
  ],
  ips: [
    {
      // eslint-disable-next-line require-await, @typescript-eslint/no-explicit-any
      validator: async (_, ips): Promise<any> => {
        if (!ips || ips.length < 1) {
          // eslint-disable-next-line unicorn/no-useless-promise-resolve-reject
          return Promise.reject(new Error('Введіть хоча б одну IP адресу'));
        }
      }
    }
  ],
  ip: [
    {
      required: true,
      type: 'string',
      pattern: /^((\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/,
      message: 'Введіть коректну IP адресу'
    },
    ({ getFieldValue }): RuleObject => ({
      validator(): Promise<void> {
        if (getFieldValue(['ips']).length !== new Set(getFieldValue(['ips'])).size) {
          return Promise.reject(new Error('Однакові IP адреси не допускаються'));
        }
        return Promise.resolve();
      }
    })
  ],
  hostingId: [{ required: true, type: 'string', message: 'Виберіть хостинг' }],
  hostingAccountId: [{ required: true, type: 'string', message: 'Виберіть акаунт хостинга' }]
};

export const proxyServersEditFormValidationSchema: ProxyServerFormValidationSchema = {
  ...proxyServersFormValidationSchema,
  password: [
    { type: 'string', message: 'Пароль має бути строкою' },
    { min: 1, max: 255, message: 'Пароль має бути довжиною не менше 1 символа та не більше 255' }
  ],
  ips: []
};
